import { Theme, makeStyles } from "@material-ui/core";
import { hexToRGB } from "src/util";

export const useStyles = makeStyles((theme: Theme) => ({
  resetToDefaultButton: {
    "&:hover": {
      backgroundColor: `rgba(${hexToRGB(theme.palette.error.main)}, 0.75)`,
    },
    backgroundColor: theme.palette.error.main,
    color: theme.palette.background.paper,
  },
}));



// WEBPACK FOOTER //
// ./src/features/director/pages/seasons/seasonsPage/components/default-settings-modal/styles.ts